import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { useEnvironment } from '@/react/portainer/environments/queries';

import { PageHeader } from '@@/PageHeader';
import { Widget, WidgetBody } from '@@/Widget';

import { OmniAddNodesForm } from './omni/OmniAddNodesForm';

export function NodeCreateView() {
  const environmentId = useEnvironmentId();
  const clusterProviderQuery = useEnvironment(environmentId, (env) => {
    const isOmniK8s = env?.CloudProvider?.Provider?.toLowerCase() === 'omni';
    return { isOmniK8s };
  });
  const { isOmniK8s } = clusterProviderQuery.data ?? {};
  return (
    <>
      <PageHeader
        title="Create nodes"
        breadcrumbs={[
          { label: 'Cluster information', link: 'kubernetes.cluster' },
          { label: 'Create nodes' },
        ]}
        reload
      />
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>{isOmniK8s && <OmniAddNodesForm />}</WidgetBody>
          </Widget>
        </div>
      </div>
    </>
  );
}
